<template>
  <aside>
    <h1>{{ $t('faq.key001') }}</h1>
    <nav>
      <ul>
        <li>
          <router-link :to="`/${currentLanguage}/faq/account-issues`" active-class="active">
            {{ $t('faq.key002') }}
          </router-link>
        </li>
        <li>
          <router-link :to="`/${currentLanguage}/faq/ticket-issues`" active-class="active">
            {{ $t('faq.key003') }}
          </router-link>
        </li>
        <li>
          <router-link :to="`/${currentLanguage}/faq/redemption-guide`" active-class="active">
            {{ $isPcBeatDayShow ? $t('faq.key004') : $t('faq.key007') }}
          </router-link>
        </li>
        <li v-if="$isPcBeatDayShow">
          <router-link :to="`/${currentLanguage}/faq/beatday-usage`" active-class="active">
            {{ $t('faq.key005') }}
          </router-link>
        </li>
        <li v-if="$isPcBeatDayShow">
          <router-link :to="`/${currentLanguage}/faq/beatday-live`" active-class="active">
            {{ $t('faq.key006') }}
          </router-link>
        </li>
        <li v-if="!$isPcBeatDayShow">
          <router-link :to="`/${currentLanguage}/faq/beatday-pcmac`" active-class="active">
            {{ $t('faq.key008') }}
          </router-link>
        </li>
        <li v-if="!$isPcBeatDayShow">
          <router-link :to="`/${currentLanguage}/faq/beatday-mobile`" active-class="active">
            {{ $t('faq.key009') }}
          </router-link>
        </li>
      </ul>
    </nav>
  </aside>
</template>

<script>
export default {
  name: 'NavAside',
  data() {
    return {};
  },
  computed: {},
  methods: {},
};
</script>

<style lang="scss"></style>
